import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

import Layout from "../components/Layout";

const Faq = () => {
  return (
    <Layout>
      <Accordion allowMultipleExpanded allowZeroExpanded>
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>
              How to delete account?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              Log into your account in the app. Then proceed to your profile, tap on the gear icon, and then press the "Delete Account" button.
            </p>

            <br />

            <p>
              Additionally, for issues pertaining to account deletion, you can contact us at the following email address:{" "}
              <a
                href="mailto:develop@petgeo.org"
                target="_blank"
                rel="noopener noreferrer"
                className="privacy__email"
              >
                develop@petgeo.org
              </a>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </Layout>
  );
};

export default Faq;
